import * as React from "react";
import { Button } from "react-ui";

import { InternalIcon } from "../../Icons/Icon";

import { WithAuto } from "./PopupTextArea.styles";
import { PopupTextAreaProps } from "./PopupTextArea";

const PopupTextAreaUndoButton = (props: PopupTextAreaProps): JSX.Element => (
    <Button
        narrow
        onClick={() => props.onChange(props.autoValue ?? "")}
        disabled={props.disabled}
        corners={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>
        <InternalIcon name={"ArrowDUturnLeftDownIcon"} />
    </Button>
);

export const PopupTextAreaWithAuto = (props: {
    popupTextAreaProps: PopupTextAreaProps;
    children: React.ReactNode;
}): JSX.Element => {
    const { children } = props;
    const { auto, autoFlag, width } = props.popupTextAreaProps;

    if (!auto) {
        return <>{children}</>;
    }

    return (
        <WithAuto width={width}>
            {!autoFlag ? <PopupTextAreaUndoButton {...props.popupTextAreaProps} /> : ""}
            {children}
        </WithAuto>
    );
};
